import { render, staticRenderFns } from "./ExitModal.vue?vue&type=template&id=0afa21d2&"
import script from "./ExitModal.vue?vue&type=script&lang=js&"
export * from "./ExitModal.vue?vue&type=script&lang=js&"
import style0 from "./ExitModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src414009122/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afa21d2')) {
      api.createRecord('0afa21d2', component.options)
    } else {
      api.reload('0afa21d2', component.options)
    }
    module.hot.accept("./ExitModal.vue?vue&type=template&id=0afa21d2&", function () {
      api.rerender('0afa21d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ExitModal.vue"
export default component.exports